export function validPassword (account) {
  const reg = /^[a-zA-Z0-9]{6,30}$/
  return reg.test(account);
}
/* 是否是公司邮箱*/
export function validEmail(str) {
  const reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/i;
  return reg.test(str);
}



// WEBPACK FOOTER //
// ./src/utils/validate.js